module.exports = __webpack_public_path__ + "static/media/undraw_working_from_anywhere_ub67.6a18a359.svg";